<style>
.popover{
  max-width: 500px!important;
}
</style>
<script>
import {  mapGetters } from "vuex"; 
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Vue from 'vue';
import { notify } from '@/helpers/notify' 
import datatableMixin from '@/helpers/mixins/datatableMixin'
import Ticket from './modals/ticket_modal.vue'

export default {
    page: {
        title: "Ticket Listesi",
    },
    mixins: [ datatableMixin ],
    components: {
        Layout,
        PageHeader,
        Ticket
    },
    computed: {
        ...mapGetters('authfack',['userdata'])
    },
    data() {
        return {
            title: "Ticket Listesi",
            items: [
                {
                    text: "ANASAYFA",
                    href: "/",
                },
                {
                    text: "TICKET LİSTESİ",
                    active: true,
                },
            ], 
            searchParams: {},
            columns: [
                    { name: 'Ticket Numarası', key: 'ticket_num',  width: "150px" },
                    { name: 'Kullanıcı Adı', key: 'username', width: "10%" },
                    { name: 'İsim Soyisim', key: 'fullname', width: "20%" },
                    { name: 'Durum', key: 'status', width: 50 },
                    { name: 'Oluşturma Tarihi', key: 'created_at', className: 'text-end', orderable: true, width: "20%"  },
                    { name: 'Oluşturan', key: 'user_name', className: 'text-end', width: "20%"  },
            ],
            tableData: {
            detail: false,
            excel: true,
                searchable:{
                    visible:true,
                    placeholder:"İsim Soyisim Ara"
                }
            },
            endpoint: '/tickets',
            modelOpen:0,
            subsId:{},
            preferred:{
                interval:2,
                status:''
            },
            intervalId: null,
            lastUpdated: null,
        };
    },
    mounted() {
        this.setRefresh(); // sayfa açıldığında başlat
    },
    beforeDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    },

  methods: {
    async loadPage() {
        this.params.page === 1 ?   this.isLoading = true : this.pageLoading = true
        
        const response = await  this.$http.post(this.endpoint, { params: this.params, search_params: this.searchParams, sort:this.sort, search_query: this.searchQuery });
        if (this.params.page === 1) {
            this.tableData.data = response.data.data;
        } else {
            this.tableData.data = [...this.tableData.data, ...response.data.data];
        }
    
        this.tableData.pagination = {  current_page:response.data.current_page,  last_page:response.data.last_page, total:response.data.total};
        this.params.page === 1 ?   this.isLoading = false : this.pageLoading = false

        this.lastUpdated = new Date().toLocaleTimeString();
    },
    
    popoverContent(histories) {
      const listItems = histories.map(history => {
        return `
          <li>${history.description}</li>
        `;
      }).join('');

      return `<ul>${listItems}</ul>`;
    },
    
    cevapver(props){
       this.modelOpen +=1
       this.subsId = { id: props.subscription_id } 
       this.$parent.$bvModal.show('ticket_modal')
    },

    created_at(obj){
        return this.formatDate(obj.created_at, "DD.MM.YYYY HH:mm")
    },

    sil(props){
      Vue.swal({
          title: "Ticket Kapanacak ?",
          showCancelButton: true,
          cancelButtonText: "Vazgeç",
          confirmButtonText: "Kapat"
      }).then((result) => {
          if (result.value) {
            this.$http.put('/tickets/' + props.id)
            .then(response => {
                if(response.data.code == 100){
                  this.loadPage()
                  return notify.success(response.data.message)
                }
                return notify.error(response.data.message)
            })
          }
      });
    },
    setRefresh() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      const converTime = (this.preferred.interval * 60) * 1000
      this.intervalId = setInterval(this.loadPage, converTime);
    },
    filter(column){
        this.searchParams = { column }
        this.loadPage()
    },
    searchQuerys(){
        if(this.searchQuery.length > 0 && this.searchQuery.length < 3) return
        this.loadPage()
    }
   }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"  :items="items" />

     <Ticket 
      :modelOpen="modelOpen" 
      :data="subsId"
     />
      
    
    <div class="d-flex justify-content-end align-items-end gap-3">
        <div class="d-flex align-items-center gap-3">
            <input type="text" class="form-control w-auto" placeholder="Ara..." v-model="searchQuery" @input="searchQuerys()">

            <select class="form-select w-auto" v-model="preferred.interval" @change="setRefresh">
                <option value="2">Oto. Yenile 2 DK</option>
                <option value="5">Oto. Yenile 5 DK</option>
                <option value="10">Oto. Yenile 10 DK</option>
            </select>
            <select class="form-select w-auto" v-model="preferred.status" @change="filter('status')">
                <option value="">Durum</option>
                <option value="0">Cevap Bekliyor</option>
                <option value="1">Çözülmüş</option>
            </select>
            
            <button class="btn btn-primary" @click="setRefresh"><i class="fa fa-refresh"></i> 
                Yenile 
            </button>
        </div>
    </div>
     <div class="d-flex justify-content-between align-items-end gap-3">
        <div>
          
        </div>
        <div class="mt-2" v-if="lastUpdated">
            Son yenilenme: {{ lastUpdated }}
        </div>
    </div>
    <div class="row mt-2"> 
      <div class="col-12">
        <div class="card mb-0">
            <div class="card-body">
                <div class="table-responsive" style="min-height: 300px;">
                    <table class="table table-hover">
                        <thead class="table-head" >
                            <tr>
                                <th style="width:2%"></th>
                                <th :style="`width:${column.width}`" v-for="(column,i) in columns"  :key="i">{{ column.name }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, rowIndex) in tableData.data" :key="rowIndex"  @click="cevapver(row)">
                                <th>{{ rowIndex+=1 }}</th>
                                <td v-for="(column, colIndex) in columns" :key="colIndex">
                                    <template v-if="column.key == 'ticket_num'"> <strong>#{{  row.ticket_num }}</strong> </template>
                                    <template v-else-if="column.key == 'created_at'"> {{ created_at(row) }} </template>
                                    <template v-else-if="column.key == 'status'">
                                        <span class="me-1 badge bg-success rounded-pill" v-if="row.status == 1">Çözülmüş</span>
                                        <span class="me-1 badge bg-warning rounded-pill" v-else>Cevap Bekliyor</span>
                                    </template>
                                    <template v-else>{{ row[column.key] }}</template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
      </div>
    </div>
  </Layout>
</template>